import { render } from "./GroupDashboardStats.vue?vue&type=template&id=766a36d6&scoped=true"
import script from "./GroupDashboardStats.vue?vue&type=script&lang=js"
export * from "./GroupDashboardStats.vue?vue&type=script&lang=js"

import "./GroupDashboardStats.vue?vue&type=style&index=0&id=766a36d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-766a36d6"]])

export default __exports__